let Index = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/index.vue');
let rule = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/rule.vue');
let topic = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/topic.vue');
let result = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/result.vue');
let share = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/share.vue');
export default [
  { path: '/:lang', name: 'Index', component: Index, meta: { isLogin: false, level: '2,4,999' } },
  { path: '/:lang/rule', name: 'rule', component: rule, meta: { isLogin: false, level: '2,4,999' } },
  { path: '/:lang/topic', name: 'topic', component: topic, meta: { isLogin: false, level: '2,4,999' } },
  { path: '/:lang/result', name: 'result', component: result, meta: { isLogin: false, level: '2,4,999' } },
  { path: '/:lang/share', name: 'share', component: share, meta: { isLogin: false, level: '2,4,999' } },
];
